import { useEffect, useState } from "react";
import { LuLoaderCircle } from "react-icons/lu";
import {
  useProjectExportsActions,
  useProjectLatestCompleteExport,
  useProjectLatestExport,
} from "../../core_stores/useProjectExportsStore";
import { useUserSubscription } from "../../core_stores/useSubscriptionStore";
import { useSubscriptionsModal } from "../../providers/SubscriptionsModalProvider";
import ProjectExportData from "./component/ProjectExportData";
import ProjectExportStartExport from "./component/ProjectExportStartExport";

export default function ProjectExport() {
  const latestExport = useProjectLatestExport();
  const latestCompleteExport = useProjectLatestCompleteExport();
  const userSubscription = useUserSubscription();

  const { initialize } = useProjectExportsActions();
  const { open: openSubscriptionsModal } = useSubscriptionsModal();

  const [isInitialized, setIsInitialized] = useState(false);

  const canExport = userSubscription?.plan !== "Dream";

  const initializeData = async () => {
    await initialize();
    setIsInitialized(true);
  };

  useEffect(() => {
    if (canExport) {
      initializeData();
    } else {
      setIsInitialized(true);
    }
  }, []);

  return (
    <div className="h-full flex flex-col gap-8 pl-6 pr-4 pt-6">
      {isInitialized ? (
        <div className="overflow-y-auto flex flex-col gap-8">
          <ProjectExportStartExport />

          {canExport && (latestExport || latestCompleteExport) && (
            <div className="flex flex-col gap-8">
              <ProjectExportData />
            </div>
          )}

          {!canExport && (
            <div className="flex flex-col gap-4 items-center justify-center px-2">
              <p className="text-center">
                Project exports are available only to active paid subscribers.
                Upgrade your plan using the button below.
              </p>
              <button
                id="export-project-upgrade-plan-btn"
                onClick={openSubscriptionsModal}
                className="bg-gradient-to-r from-fuchsia-500 to-violet-500 
            text-white font-semibold px-5 py-2 
                rounded-lg shadow hover:opacity-90 transition"
              >
                Upgrade Plan
              </button>
            </div>
          )}
        </div>
      ) : (
        <div className="flex items-center justify-center flex-1 mb-8">
          <LuLoaderCircle className="animate-spin" size={24} />
        </div>
      )}
    </div>
  );
}
